module.exports = __webpack_public_path__ + "static/media/ckad_logo.09f90c9d.png";